import ApplyRounding from "../../../../../../../utils/math/ApplyRounding";

export function orbDetailParser(_root, softOrder) {
  const tradePlanId = softOrder.tradePlanId;
  const tacticValue = softOrder.value.tacticValue;
  const candleDuration = tacticValue.candleDuration;
  const breakBy = tacticValue.breakBy;
  const priceToBreak = tacticValue.priceToBreak || null;
  const priceToBreakHigh = tacticValue['priceToBreak (long)'] || null;
  const priceToBreakLow = tacticValue['priceToBreak (short)'] || null;
  let breakPrice = null;
  if (priceToBreak) breakPrice = '$' + ApplyRounding(priceToBreak, 2);
  if (priceToBreakHigh) {
    breakPrice = `$${ApplyRounding(priceToBreakLow, 2)}/$${ApplyRounding(
      priceToBreakHigh,
      2
    )}`;
  }
  return {
    details: {
      candleDuration,
      breakBy,
      breakPrice,
      tradePlanId,
    },
    triggerPrice: {
      priceToBreak,
      priceToBreakHigh,
      priceToBreakLow,
    },
  };
}
